module.exports = __webpack_public_path__ + "static/media/SF UI Display Bold.7701d4cf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Bold.eot
// module id = 72
// module chunks = 0